import ToggleStickyHeader from 'static-components/src/header';
var HelperSetup = /** @class */ (function () {
    function HelperSetup() {
    }
    HelperSetup.initialApplicationSetup = function () {
        HelperSetup.initStickyHeader();
    };
    HelperSetup.initStickyHeader = function () {
        if (document.getElementsByClassName('js-searchbox-container').length > 0) {
            var searchboxGrid = document.getElementsByClassName('js-searchbox-container')[0];
            if (searchboxGrid.getBoundingClientRect().height) {
                new ToggleStickyHeader();
            }
        }
        if (document.getElementsByClassName('c-header-stage__searchbox--lturfly').length > 0) {
            var header = document.getElementsByClassName('c-header-stage__searchbox--lturfly')[0];
            if (header.getBoundingClientRect().height) {
                new ToggleStickyHeader();
            }
        }
    };
    return HelperSetup;
}());
export default HelperSetup;
